import Vue from "vue";
import Router from "vue-router";

// technical-statistics
const ActiveBacklog = () =>
  import("@/views/base/technical-statistics/ActiveBacklog.vue");
const ReceivedEquipment = () =>
  import("@/views/base/technical-statistics/ReceivedEquipment.vue");
const AnalyticsByModel = () =>
  import("@/views/base/technical-statistics/AnalyticsByModel.vue");
const RegionalAnalytics = () =>
  import("@/views/base/technical-statistics/RegionalAnalytics.vue");
const SubDivisionFinancial = () =>
  import("@/views/base/technical-statistics/SubDivisionFinancial.vue");
const BeyondEconomicalRepair = () =>
  import("@/views/base/technical-statistics/BeyondEconomicalRepair.vue");
const EndOfLife = () =>
  import("@/views/base/technical-statistics/EndOfLife.vue");
const NoTroubleFound = () =>
  import("@/views/base/technical-statistics/NoTroubleFound.vue");
const UnderWarranty = () =>
  import("@/views/base/technical-statistics/UnderWarranty.vue");
const TurnAroundTime = () =>
  import("@/views/base/technical-statistics/TurnAroundTime.vue");
const OemRepair = () =>
  import("@/views/base/technical-statistics/OemRepair.vue");

// summary-report
const TechnicalReports = () =>
  import("@/views/base/summary-report/TechnicalReports.vue");
const FinancialReports = () =>
  import("@/views/base/summary-report/FinancialReports.vue");
const ExchangeReports = () =>
  import("@/views/base/summary-report/ExchangeReports");
const ProofOfDelivery = () =>
  import("@/views/base/summary-report/ProofOfDelivery");
const ProofOfDeliveryDetails = () =>
  import("@/views/base/summary-report/ProofOfDeliveryDetails");

// account
const Inbox = () => import("@/views/base/account/Inbox.vue");

// tools
const Inventory = () => import("@/views/base/tools/Inventory.vue");
const AddNewItem = () => import("@/views/base/tools/AddNewItem");

// tables
const TableAllData = () => import("@/views/base/tables/TableAllData.vue");
const TableAllDataPaginated = () =>
  import("@/views/base/tables/TableAllDataPaginated.vue");
const TableAllDataC = () => import("@/views/base/tables/TableAllDataC.vue");
const Tables = () => import("@/views/base/tables/Tables");

// maps
const Map = () => import("@/views/base/maps/Map.vue");
const MapByState = () => import("@/views/base/maps/MapByState");

const DefaultContainer = () =>
  import("@/components/containers/DefaultContainer");

//dashboard
const Dashboard = () => import("@/views/base/dashboard/Dashboard");
const CityDashboard = () => import("@/views/base/dashboard/CityDashboard.vue");
const LocationInformation = () =>
  import("@/components/city-dashboard/LocationInformation");
const ModelDashboard = () => import("@/views/base/dashboard/ModelDashboard");

//toolbar
const ProfileSettings = () =>
  import("@/views/base/toolbar/ProfileSettings.vue");
const Search = () => import("@/views/base/toolbar/Search.vue");

const Page404 = () => import("@/views/pages/Page404");
const Login = () => import("@/views/pages/Login");
const ForgotPassword = () => import("@/views/pages/ForgotPassword");

Vue.use(Router);

export default new Router({
  mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      name: "Home",
      component: DefaultContainer,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard
        },
        {
          path: "search",
          name: "Search Form",
          component: Search,
          props(route) {
            return route.query || {};
          }
        },
        {
          path: "base/ProofOfDelivery",
          name: "Proof Of Delivery",
          component: ProofOfDelivery
        },
        {
          path: "base/ProofOfDelivery/details",
          name: "Proof Of Delivery Details",
          component: ProofOfDeliveryDetails,
          props(route) {
            return route.query || {};
          }
        },
        {
          path: "ModelDashboard",
          name: "ModelDashboard",
          component: ModelDashboard,
          props(route) {
            return route.query || {};
          }
        },
        {
          path: "base",
          redirect: "/base/cards",
          name: "Base",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "inbox",
              name: "Direct Messages",
              component: Inbox
            },
            {
              path: "ProfileSettings",
              name: "Profile Settings",
              component: ProfileSettings
            },
            {
              path: "forms",
              name: "Forms",
              component: AddNewItem
            },
            {
              path: "AnalyticsByModel",
              name: "AnalyticsByModel",
              component: AnalyticsByModel
            },
            {
              path: "RegionalAnalytics",
              name: "Regional Analytics",
              component: RegionalAnalytics
            },
            {
              path: "SubDivisionFinancial",
              name: "Sub Division Financial",
              component: SubDivisionFinancial
            },
            {
              path: "BeyondEconomicalRepair",
              name: "Beyond Economical Repair",
              component: BeyondEconomicalRepair
            },
            {
              path: "EndOfLife",
              name: "End Of Life",
              component: EndOfLife
            },
            {
              path: "NoTroubleFound",
              name: "No Trouble Found",
              component: NoTroubleFound
            },
            {
              path: "UnderWarranty",
              name: "Under Warranty",
              component: UnderWarranty
            },
            {
              path: "TurnAroundTime",
              name: "Turn Around Time",
              component: TurnAroundTime
            },
            {
              path: "OemRepair",
              name: "Oem Repair",
              component: OemRepair
            },
            {
              path: "TechnicalReports",
              name: "Technical Reports",
              component: TechnicalReports
            },
            {
              path: "ExchangeReports",
              name: "ExchangeReports",
              component: ExchangeReports
            },
            {
              path: "FinancialReports",
              name: "Financial Reports",
              component: FinancialReports
            },
            {
              path: "AddNewItem",
              name: "Add New Inventory Item",
              component: AddNewItem
            },
            {
              path: "Inventory",
              name: "Repaired Inventory",
              component: Inventory
            },
            {
              path: "ActiveBacklog",
              name: "Active Backlog",
              component: ActiveBacklog
            },
            {
              path: "ReceivedEquipment",
              name: "Received Equipment",
              component: ReceivedEquipment
            },

            {
              path: "Map",
              name: "Map Overview",
              component: Map
            },
            {
              path: "tables",
              name: "Tables",
              component: Tables,
              props(route) {
                return route.query || {};
              }
            },
            {
              path: "TableAllData",
              name: "TableAllData",
              component: TableAllData,
              props(route) {
                return route.query || {};
              }
            },
            {
              path: "TableAllDataPaginated",
              name: "TableAllDataPaginated",
              component: TableAllDataPaginated,
              props(route) {
                return route.query || {};
              }
            },
            {
              path: "TableAllDataC",
              name: "TableAllDataC",
              component: TableAllDataC,
              props(route) {
                return route.query || {};
              }
            },
            {
              path: "CityDashboard",
              name: "City Dashboard",
              component: CityDashboard,
              props(route) {
                return route.query || {};
              }
            },
            {
              path: "LocationInformation",
              name: "Location Information",
              component: LocationInformation,
              props(route) {
                return route.query || {};
              }
            },
            {
              path: "MapByState",
              name: "Map By State",
              component: MapByState,
              props(route) {
                return route.query || {};
              }
            }
          ]
        }
      ]
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404
        },
        {
          path: "login",
          name: "Login",
          component: Login
        },
        {
          path:"forgot-password",
          name: "forgot-password",
          component: ForgotPassword
        }
      ]
    }
  ]
});
